const data =
	[
		{
			"id": 860,
			"status": "complete",
			"region": "east",
			"type": "team_night",
			"linked_contest_id": null,
			"position": 1,
			"name": "Blazin' Trivia",
			"sponsor": "michelob_ultra_dulce_vida",
			// tslint:disable-next-line:no-duplicate-string
			"start_date_time": "2021-05-24T08:18:00-04:00",
			// tslint:disable-next-line:no-duplicate-string
			"end_date_time": "2021-05-24T09:03:02-04:00",
			"number_rounds": 7,
			"is_herd": false,
			"voided_at": null,
			"rounds": [
				{
					"id": 21219,
					"position": 1,
					"sponsor": null,
					"status": "complete",
					"name": "warm_ups",
					// tslint:disable-next-line:no-duplicate-string
					"category": "Fashion and Beauty",
					"tag_line": "Stretch and get the kinks out.",
					"type": "normal",
					"time_to_answer": 20,
					"start_date_time": "2021-05-24T08:18:00-04:00",
					"number_questions": 5,
					"points_per_question": 20,
					"time_until_next_round": 293,
					"bonus_points": 50,
					"questions": [
						{
							"id": 133093,
							"position": 1,
							"round_id": 21219,
							"status": "complete",
							"title": "Women's fashion of the 1940's featured slim waists and what kind of shoulders?",
							"category": "Fashion and Beauty",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:18:00-04:00",
							"end_date_time": "2021-05-24T08:18:20-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342610,
									"title": "Wide",
									"question_id": 133093,
									"round_id": 21219,
									"value": 1,
									"percents": 100
								},
								{
									"id": 342611,
									"title": "Split",
									"question_id": 133093,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342612,
									"title": "Uneven",
									"question_id": 133093,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342613,
									"title": "Narrow",
									"question_id": 133093,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133094,
							"position": 2,
							"round_id": 21219,
							"status": "complete",
							"title": "In 2010, Lady Gaga wore a dress made of cheese to the MTV Video Music Awards.",
							"category": "Fashion and Beauty",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:18:37-04:00",
							"end_date_time": "2021-05-24T08:18:57-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342614,
									"title": "TRUE",
									"question_id": 133094,
									"round_id": 21219,
									"value": 0,
									"percents": 25
								},
								{
									"id": 342615,
									"title": "FALSE",
									"question_id": 133094,
									"round_id": 21219,
									"value": 1,
									"percents": 75
								}
							]
						},
						{
							"id": 133095,
							"position": 3,
							"round_id": 21219,
							"status": "complete",
							"title": "What nationality are Dolce and Gabbana?",
							"category": "Fashion and Beauty",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:19:14-04:00",
							"end_date_time": "2021-05-24T08:19:34-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342616,
									"title": "German",
									"question_id": 133095,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342617,
									"title": "Italian",
									"question_id": 133095,
									"round_id": 21219,
									"value": 1,
									"percents": 66.67
								},
								{
									"id": 342618,
									"title": "French",
									"question_id": 133095,
									"round_id": 21219,
									"value": 0,
									"percents": 33.33
								},
								{
									"id": 342619,
									"title": "Russian",
									"question_id": 133095,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133096,
							"position": 4,
							"round_id": 21219,
							"status": "complete",
							"title": "Mount Rainier National Park is about 59 miles south-southeast of Seattle, Washington.",
							"category": "Geography",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:19:51-04:00",
							"end_date_time": "2021-05-24T08:20:11-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342620,
									"title": "TRUE",
									"question_id": 133096,
									"round_id": 21219,
									"value": 1,
									"percents": 100
								},
								{
									"id": 342621,
									"title": "FALSE",
									"question_id": 133096,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133097,
							"position": 5,
							"round_id": 21219,
							"status": "complete",
							"title": "Cincinnati is located on what major North American river?",
							"category": "Geography",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:20:28-04:00",
							"end_date_time": "2021-05-24T08:20:48-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342622,
									"title": "Great Miami",
									"question_id": 133097,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342623,
									"title": "Scioto",
									"question_id": 133097,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342624,
									"title": "Mississippi",
									"question_id": 133097,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342625,
									"title": "Ohio",
									"question_id": 133097,
									"round_id": 21219,
									"value": 1,
									"percents": 100
								}
							]
						}
					]
				},
				{
					"id": 21220,
					"position": 2,
					"sponsor": null,
					"status": "complete",
					"name": "omg",
					"category": "Fashion and Beauty",
					"tag_line": "Fashion, Beauty, and Other Unattainables",
					"type": "rapid_fire_2",
					"time_to_answer": 20,
					// tslint:disable-next-line:no-duplicate-string
					"start_date_time": "2021-05-24T08:25:48-04:00",
					"number_questions": 5,
					"points_per_question": 20,
					"time_until_next_round": 293,
					"bonus_points": 50,
					"questions": [
						{
							"id": 133098,
							"position": 1,
							"round_id": 21220,
							"status": "complete",
							"title": "Which of these does the Nike trademark called a \"swoosh\" most resemble?",
							"category": "Fashion and Beauty",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:25:48-04:00",
							"end_date_time": "2021-05-24T08:26:08-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342626,
									"title": "A Number Sign",
									"question_id": 133098,
									"round_id": 21220,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342627,
									"title": "A Check Mark",
									"question_id": 133098,
									"round_id": 21220,
									"value": 1,
									"percents": 100
								},
								{
									"id": 342628,
									"title": "A Peace Sign",
									"question_id": 133098,
									"round_id": 21220,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342629,
									"title": "A Star",
									"question_id": 133098,
									"round_id": 21220,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133099,
							"position": 2,
							"round_id": 21220,
							"status": "complete",
							"title": "According to a well-known movie starring Meryl Streep, the devil wears Prada.",
							"category": "Fashion and Beauty",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:26:25-04:00",
							"end_date_time": "2021-05-24T08:26:45-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342630,
									"title": "TRUE",
									"question_id": 133099,
									"round_id": 21220,
									"value": 1,
									"percents": 83.33
								},
								{
									"id": 342631,
									"title": "FALSE",
									"question_id": 133099,
									"round_id": 21220,
									"value": 0,
									"percents": 16.67
								}
							]
						},
						{
							"id": 133100,
							"position": 3,
							"round_id": 21220,
							"status": "complete",
							"title": "Which French monarch was known for his fancy taste, especially in velvets and laces?",
							"category": "Fashion and Beauty",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:27:02-04:00",
							"end_date_time": "2021-05-24T08:27:22-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342632,
									"title": "Napoleon",
									"question_id": 133100,
									"round_id": 21220,
									"value": 0,
									"percents": 20
								},
								{
									"id": 342633,
									"title": "King Louis XIV",
									"question_id": 133100,
									"round_id": 21220,
									"value": 1,
									"percents": 60
								},
								{
									"id": 342634,
									"title": "Ivan The Terrible",
									"question_id": 133100,
									"round_id": 21220,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342635,
									"title": "Charlemagne",
									"question_id": 133100,
									"round_id": 21220,
									"value": 0,
									"percents": 20
								}
							]
						},
						{
							"id": 133101,
							"position": 4,
							"round_id": 21220,
							"status": "complete",
							"title": "In 2019, Forbes categorized Kylie Jenner as a billionaire due to the success of her cosmetics company.",
							"category": "Fashion and Beauty",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:27:39-04:00",
							"end_date_time": "2021-05-24T08:27:59-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342636,
									"title": "TRUE",
									"question_id": 133101,
									"round_id": 21220,
									"value": 1,
									"percents": 66.67
								},
								{
									"id": 342637,
									"title": "FALSE",
									"question_id": 133101,
									"round_id": 21220,
									"value": 0,
									"percents": 33.33
								}
							]
						},
						{
							"id": 133102,
							"position": 5,
							"round_id": 21220,
							"status": "complete",
							"title": "By what name do we know the item Whitcomb Judson called a \"clasp locker\"?",
							"category": "Fashion and Beauty",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:28:16-04:00",
							"end_date_time": "2021-05-24T08:28:36-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342638,
									"title": "Velcro",
									"question_id": 133102,
									"round_id": 21220,
									"value": 0,
									"percents": 50
								},
								{
									"id": 342639,
									"title": "Snap",
									"question_id": 133102,
									"round_id": 21220,
									"value": 0,
									"percents": 37.5
								},
								{
									"id": 342640,
									"title": "Button Fly",
									"question_id": 133102,
									"round_id": 21220,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342641,
									"title": "Zipper",
									"question_id": 133102,
									"round_id": 21220,
									"value": 1,
									"percents": 12.5
								}
							]
						}
					]
				},
				{
					"id": 21222,
					"position": 3,
					"sponsor": null,
					"status": "scheduled",
					"name": "balls_and_bats",
					"category": "Sports",
					"tag_line": "Sports Trivia; Because we're a sports bar",
					"type": "rapid_fire_2",
					"time_to_answer": 20,
					// tslint:disable-next-line:no-duplicate-string
					"start_date_time": "2021-05-24T08:33:36-04:00",
					"number_questions": 5,
					"points_per_question": 20,
					"time_until_next_round": 285,
					"bonus_points": 50,
					"questions": [
						{
							"id": 133103,
							"position": 1,
							"round_id": 21222,
							"status": "complete",
							"title": "Stephen Curry scored 62 points in January 2021 against which team?",
							"category": "Sports",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:33:36-04:00",
							"end_date_time": "2021-05-24T08:33:56-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342642,
									"title": "Lakers",
									"question_id": 133103,
									"round_id": 21222,
									"value": 0,
									"percents": 14.29
								},
								{
									"id": 342643,
									"title": "Magic",
									"question_id": 133103,
									"round_id": 21222,
									"value": 0,
									"percents": 14.29
								},
								{
									"id": 342644,
									"title": "Trail Blazers",
									"question_id": 133103,
									"round_id": 21222,
									"value": 1,
									"percents": 71.43
								},
								{
									"id": 342645,
									"title": "Bulls",
									"question_id": 133103,
									"round_id": 21222,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133104,
							"position": 2,
							"round_id": 21222,
							"status": "complete",
							"title": "Chicago Loyola was the first 16 seed to ever defeat a #1 seed in the NCAA men's basketball tournament.",
							"category": "Sports",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:34:13-04:00",
							"end_date_time": "2021-05-24T08:34:33-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342646,
									"title": "TRUE",
									"question_id": 133104,
									"round_id": 21222,
									"value": 0,
									"percents": 77.78
								},
								{
									"id": 342647,
									"title": "FALSE",
									"question_id": 133104,
									"round_id": 21222,
									"value": 1,
									"percents": 22.22
								}
							]
						},
						{
							"id": 133105,
							"position": 3,
							"round_id": 21222,
							"status": "complete",
							"title": "What did the Cavs get for the trade of Kevin Porter Jr. to the Rockets in 2021?",
							"category": "Sports",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:34:50-04:00",
							"end_date_time": "2021-05-24T08:35:10-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342648,
									"title": "Rodions Kurucs",
									"question_id": 133105,
									"round_id": 21222,
									"value": 0,
									"percents": 33.33
								},
								{
									"id": 342649,
									"title": "Future Second-Round Pick",
									"question_id": 133105,
									"round_id": 21222,
									"value": 1,
									"percents": 33.33
								},
								{
									"id": 342650,
									"title": "Cash",
									"question_id": 133105,
									"round_id": 21222,
									"value": 0,
									"percents": 11.11
								},
								{
									"id": 342651,
									"title": "Future First-Round Pick",
									"question_id": 133105,
									"round_id": 21222,
									"value": 0,
									"percents": 22.22
								}
							]
						},
						{
							"id": 133106,
							"position": 4,
							"round_id": 21222,
							"status": "complete",
							"title": "In 2020, the Buffalo Bills won the AFC East for the first time since 1993.",
							"category": "Sports",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:35:27-04:00",
							"end_date_time": "2021-05-24T08:35:47-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342652,
									"title": "TRUE",
									"question_id": 133106,
									"round_id": 21222,
									"value": 1,
									"percents": 87.5
								},
								{
									"id": 342653,
									"title": "FALSE",
									"question_id": 133106,
									"round_id": 21222,
									"value": 0,
									"percents": 12.5
								}
							]
						},
						{
							"id": 133107,
							"position": 5,
							"round_id": 21222,
							"status": "complete",
							"title": "Who won the NHL's Norris Trophy every year from 1968 to 1975?",
							"category": "Sports",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:36:04-04:00",
							"end_date_time": "2021-05-24T08:36:24-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342654,
									"title": "Bobby Orr",
									"question_id": 133107,
									"round_id": 21222,
									"value": 1,
									"percents": 75
								},
								{
									"id": 342655,
									"title": "Bobby Hull",
									"question_id": 133107,
									"round_id": 21222,
									"value": 0,
									"percents": 12.5
								},
								{
									"id": 342656,
									"title": "Larry Robinson",
									"question_id": 133107,
									"round_id": 21222,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342657,
									"title": "Wayne Gretzky",
									"question_id": 133107,
									"round_id": 21222,
									"value": 0,
									"percents": 12.5
								}
							]
						}
					]
				},
				{
					"id": 21226,
					"position": 4,
					"sponsor": "michelob_ultra_dulce_vida",
					"status": "scheduled",
					"name": "michelob_ultra_dulce_vida",
					// tslint:disable-next-line:no-duplicate-string
					"category": "Two Rights and a Wrong",
					"tag_line": "",
					"type": "right_right_wrong",
					"time_to_answer": 20,
					// tslint:disable-next-line:no-duplicate-string
					"start_date_time": "2021-05-24T08:41:16-04:00",
					"number_questions": 5,
					"points_per_question": 20,
					"time_until_next_round": 362,
					"bonus_points": 50,
					"questions": [
						{
							"id": 133114,
							"position": 1,
							"round_id": 21226,
							"status": "complete",
							"title": "Stephen \"Steph\" Curry",
							"category": "Two Rights and a Wrong",
							"answer_type": "multi_select",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:41:16-04:00",
							"end_date_time": "2021-05-24T08:41:36-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342669,
									"title": "Duke University",
									"question_id": 133114,
									"round_id": 21226,
									"value": 0,
									"percents": 30.77
								},
								{
									"id": 342670,
									"title": "Ayesha Curry",
									"question_id": 133114,
									"round_id": 21226,
									"value": 1,
									"percents": 69.23
								}
							]
						},
						{
							"id": 133115,
							"position": 2,
							"round_id": 21226,
							"status": "complete",
							"title": "Major League Baseball Managers 2021",
							"category": "Two Rights and a Wrong",
							"answer_type": "multi_select",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:41:53-04:00",
							"end_date_time": "2021-05-24T08:42:13-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342671,
									"title": "Craig Counsell",
									"question_id": 133115,
									"round_id": 21226,
									"value": 1,
									"percents": 71.43
								},
								{
									"id": 342672,
									"title": "Al Avila",
									"question_id": 133115,
									"round_id": 21226,
									"value": 0,
									"percents": 28.57
								}
							]
						},
						{
							"id": 133116,
							"position": 3,
							"round_id": 21226,
							"status": "complete",
							"title": "Olympic Swimmers",
							"category": "Two Rights and a Wrong",
							"answer_type": "multi_select",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:42:30-04:00",
							"end_date_time": "2021-05-24T08:42:50-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342673,
									"title": "Matt Biondi",
									"question_id": 133116,
									"round_id": 21226,
									"value": 1,
									"percents": 23.08
								},
								{
									"id": 342674,
									"title": "Ryan Lochte",
									"question_id": 133116,
									"round_id": 21226,
									"value": 1,
									"percents": 76.92
								}
							]
						},
						{
							"id": 133117,
							"position": 4,
							"round_id": 21226,
							"status": "complete",
							"title": "NBA Head Coaches 2021",
							"category": "Two Rights and a Wrong",
							"answer_type": "multi_select",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:43:07-04:00",
							"end_date_time": "2021-05-24T08:43:27-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342675,
									"title": "Chris Lynn",
									"question_id": 133117,
									"round_id": 21226,
									"value": 0,
									"percents": 69.23
								},
								{
									"id": 342676,
									"title": "Michael Malone",
									"question_id": 133117,
									"round_id": 21226,
									"value": 1,
									"percents": 30.77
								}
							]
						},
						{
							"id": 133118,
							"position": 5,
							"round_id": 21226,
							"status": "complete",
							"title": "Archery Terms",
							"category": "Two Rights and a Wrong",
							"answer_type": "multi_select",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:43:44-04:00",
							"end_date_time": new Date(Date.now() + 20 * 1000),
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342677,
									"title": "Hug the Rail",
									"question_id": 133118,
									"round_id": 21226,
									"value": 0,
									"percents": 53.85
								},
								{
									"id": 342678,
									"title": "Bowyer",
									"question_id": 133118,
									"round_id": 21226,
									"value": 1,
									"percents": 46.15
								}
							]
						}
					]
				},
				{
					"id": 21223,
					"position": 5,
					"sponsor": null,
					"status": "scheduled",
					"name": "blazin_round",
					"category": "Swipe It",
					"tag_line": "To know us is to love us",
					"type": "this_or_that",
					"time_to_answer": 12,
					// tslint:disable-next-line:no-duplicate-string
					"start_date_time": "2021-05-24T08:50:13-04:00",
					"number_questions": 5,
					"points_per_question": 30,
					"time_until_next_round": 280,
					"bonus_points": 50,
					"questions": [
						{
							"id": 133108,
							"position": 1,
							"round_id": 21223,
							"status": "complete",
							"title": "Michigan",
							"category": "Swipe It",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:50:13-04:00",
							// tslint:disable-next-line:no-duplicate-string
							"end_date_time": "2021-05-24T08:50:25-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342658,
									// tslint:disable-next-line:no-duplicate-string
									"title": "States West of the Mississippi",
									"question_id": 133108,
									"round_id": 21223,
									"value": 0,
									"percents": 12.5
								},
								{
									"id": 342659,
									// tslint:disable-next-line:no-duplicate-string
									"title": "States East of the Mississippi",
									"question_id": 133108,
									"round_id": 21223,
									"value": 1,
									"percents": 87.5
								}
							]
						},
						{
							"id": 133109,
							"position": 2,
							"round_id": 21223,
							"status": "complete",
							"title": "Kansas Michigan Michigan Michigan Michigan Michigan Michigan Michigan Michigan Michigan Michigan Michigan Michigan  ",
							"category": "Swipe It",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:50:25-04:00",
							// tslint:disable-next-line:no-duplicate-string
							"end_date_time": "2021-05-24T08:50:37-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342660,
									"title": "States West of the Mississippi",
									"question_id": 133109,
									"round_id": 21223,
									"value": 1,
									"percents": 87.5
								},
								{
									"id": 342661,
									"title": "States East of the Mississippi",
									"question_id": 133109,
									"round_id": 21223,
									"value": 0,
									"percents": 12.5
								}
							]
						},
						{
							"id": 133110,
							"position": 3,
							"round_id": 21223,
							"status": "complete",
							"title": "Idaho",
							"category": "Swipe It",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:50:37-04:00",
							// tslint:disable-next-line:no-duplicate-string
							"end_date_time": "2021-05-24T08:50:49-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342662,
									"title": "States West of the Mississippi",
									"question_id": 133110,
									"round_id": 21223,
									"value": 1,
									"percents": 100
								},
								{
									"id": 342663,
									"title": "States East of the Mississippi",
									"question_id": 133110,
									"round_id": 21223,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133111,
							"position": 4,
							"round_id": 21223,
							"status": "complete",
							"title": "Louisiana",
							"category": "Swipe It",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:50:49-04:00",
							// tslint:disable-next-line:no-duplicate-string
							"end_date_time": "2021-05-24T08:51:01-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342664,
									"title": "States West of the Mississippi",
									"question_id": 133111,
									"round_id": 21223,
									"value": 1,
									"percents": 37.5
								},
								{
									"id": 342665,
									"title": "States East of the Mississippi",
									"question_id": 133111,
									"round_id": 21223,
									"value": 0,
									"percents": 62.5
								}
							]
						},
						{
							"id": 133112,
							"position": 5,
							"round_id": 21223,
							"status": "complete",
							"title": "Mississippi",
							"category": "Swipe It",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:51:01-04:00",
							"end_date_time": "2021-05-24T08:51:13-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342666,
									"title": "States West of the Mississippi",
									"question_id": 133112,
									"round_id": 21223,
									"value": 0,
									"percents": 25
								},
								{
									"id": 342667,
									"title": "States East of the Mississippi",
									"question_id": 133112,
									"round_id": 21223,
									"value": 1,
									"percents": 75
								}
							]
						}
					]
				},
				{
					"id": 21224,
					"position": 6,
					"sponsor": null,
					"status": "scheduled",
					"name": "icymi",
					"category": "All",
					"tag_line": "In Case You Missed It",
					"type": "normal",
					"time_to_answer": 20,
					// tslint:disable-next-line:no-duplicate-string
					"start_date_time": "2021-05-24T08:56:03-04:00",
					"number_questions": 2,
					"points_per_question": 20,
					"time_until_next_round": 325,
					"bonus_points": 50,
					"questions": [
						{
							"id": 133119,
							"position": 1,
							"round_id": 21224,
							"status": "complete",
							"title": "The movie “Shrek” was released 20 years ago. Who was originally cast to play the titular ogre?",
							"category": "All",
							"answer_type": "multiple_choice",
							"fun_fact": "The former “Saturday Night Live” star Chris Farley was originally cast and had recorded many of his lines before his death in 1997.",
							"start_date_time": "2021-05-24T08:56:03-04:00",
							"end_date_time": "2021-05-24T08:56:23-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 10,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342679,
									"title": "Eddie Murphy",
									"question_id": 133119,
									"round_id": 21224,
									"value": 0,
									"percents": 20
								},
								{
									"id": 342680,
									"title": "Jack Black",
									"question_id": 133119,
									"round_id": 21224,
									"value": 0,
									"percents": 20
								},
								{
									"id": 342681,
									"title": "Chris Farley",
									"question_id": 133119,
									"round_id": 21224,
									"value": 1,
									"percents": 60
								},
								{
									"id": 342682,
									"title": "Mike Myers",
									"question_id": 133119,
									"round_id": 21224,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133120,
							"position": 2,
							"round_id": 21224,
							"status": "complete",
							"title": "Phil Mickelson won the PGA championship over the weekend. How many major championships has he won?",
							"category": "All",
							"answer_type": "multiple_choice",
							"fun_fact": "",
							"start_date_time": "2021-05-24T08:56:50-04:00",
							"end_date_time": "2021-05-24T08:57:10-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342683,
									"title": "Five",
									"question_id": 133120,
									"round_id": 21224,
									"value": 0,
									"percents": 16.67
								},
								{
									"id": 342684,
									"title": "Ten",
									"question_id": 133120,
									"round_id": 21224,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342685,
									"title": "Four",
									"question_id": 133120,
									"round_id": 21224,
									"value": 0,
									"percents": 5.56
								},
								{
									"id": 342686,
									"title": "Six",
									"question_id": 133120,
									"round_id": 21224,
									"value": 1,
									"percents": 77.78
								}
							]
						}
					]
				},
				{
					"id": 21225,
					"position": 7,
					"sponsor": null,
					"status": "scheduled",
					"name": "finals",
					"category": "Literature",
					"tag_line": "GOATs only.",
					"type": "wager",
					"time_to_answer": 20,
					// tslint:disable-next-line:no-duplicate-string
					"start_date_time": "2021-05-24T09:02:42-04:00",
					"number_questions": 1,
					"points_per_question": 50,
					"time_until_next_round": 60,
					"bonus_points": 0,
					"questions": [
						{
							"id": 133113,
							"position": 1,
							"round_id": 21225,
							"status": "complete",
							"title": "Who wrote the book \"The Count of Monte Cristo\"?",
							"category": "Finals",
							"answer_type": "free_response",
							"fun_fact": null,
							"start_date_time": "2021-05-24T09:02:42-04:00",
							"end_date_time": "2021-05-24T09:03:02-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342668,
									"title": "",
									"question_id": 133113,
									"round_id": 21225,
									// tslint:disable-next-line:no-duplicate-string
									"value": "Alexandre Dumas",
									"variants": [
										"Alexandre Dumas"
									],
									"percents": 16.67
								}
							]
						}
					]
				}
			]
		},
		{
			"id": 861,
			"status": "scheduled",
			"region": "east",
			"type": "team_night",
			"linked_contest_id": null,
			"position": 1,
			"name": "Blazin' Trivia",
			"sponsor": "michelob_ultra_dulce_vida",
			"start_date_time": "2021-05-24T08:18:00-04:00",
			"end_date_time": "2021-05-24T09:03:02-04:00",
			"number_rounds": 7,
			"is_herd": false,
			"voided_at": null,
			"rounds": [
				{
					"id": 21219,
					"position": 1,
					"sponsor": null,
					"status": "complete",
					"name": "warm_ups",
					"category": "Fashion and Beauty",
					"tag_line": "Stretch and get the kinks out.",
					"type": "normal",
					"time_to_answer": 20,
					"start_date_time": "2021-05-24T08:18:00-04:00",
					"number_questions": 5,
					"points_per_question": 20,
					"time_until_next_round": 293,
					"bonus_points": 50,
					"questions": [
						{
							"id": 133093,
							"position": 1,
							"round_id": 21219,
							"status": "complete",
							"title": "Women's fashion of the 1940's featured slim waists and what kind of shoulders?",
							"category": "Fashion and Beauty",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:18:00-04:00",
							"end_date_time": "2021-05-24T08:18:20-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342610,
									"title": "Wide",
									"question_id": 133093,
									"round_id": 21219,
									"value": 1,
									"percents": 100
								},
								{
									"id": 342611,
									"title": "Split",
									"question_id": 133093,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342612,
									"title": "Uneven",
									"question_id": 133093,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342613,
									"title": "Narrow",
									"question_id": 133093,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133094,
							"position": 2,
							"round_id": 21219,
							"status": "complete",
							"title": "In 2010, Lady Gaga wore a dress made of cheese to the MTV Video Music Awards.",
							"category": "Fashion and Beauty",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:18:37-04:00",
							"end_date_time": "2021-05-24T08:18:57-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342614,
									"title": "TRUE",
									"question_id": 133094,
									"round_id": 21219,
									"value": 0,
									"percents": 25
								},
								{
									"id": 342615,
									"title": "FALSE",
									"question_id": 133094,
									"round_id": 21219,
									"value": 1,
									"percents": 75
								}
							]
						},
						{
							"id": 133095,
							"position": 3,
							"round_id": 21219,
							"status": "complete",
							"title": "What nationality are Dolce and Gabbana?",
							"category": "Fashion and Beauty",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:19:14-04:00",
							"end_date_time": "2021-05-24T08:19:34-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342616,
									"title": "German",
									"question_id": 133095,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342617,
									"title": "Italian",
									"question_id": 133095,
									"round_id": 21219,
									"value": 1,
									"percents": 66.67
								},
								{
									"id": 342618,
									"title": "French",
									"question_id": 133095,
									"round_id": 21219,
									"value": 0,
									"percents": 33.33
								},
								{
									"id": 342619,
									"title": "Russian",
									"question_id": 133095,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133096,
							"position": 4,
							"round_id": 21219,
							"status": "complete",
							"title": "Mount Rainier National Park is about 59 miles south-southeast of Seattle, Washington.",
							"category": "Geography",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:19:51-04:00",
							"end_date_time": "2021-05-24T08:20:11-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342620,
									"title": "TRUE",
									"question_id": 133096,
									"round_id": 21219,
									"value": 1,
									"percents": 100
								},
								{
									"id": 342621,
									"title": "FALSE",
									"question_id": 133096,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133097,
							"position": 5,
							"round_id": 21219,
							"status": "complete",
							"title": "Cincinnati is located on what major North American river?",
							"category": "Geography",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:20:28-04:00",
							"end_date_time": "2021-05-24T08:20:48-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342622,
									"title": "Great Miami",
									"question_id": 133097,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342623,
									"title": "Scioto",
									"question_id": 133097,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342624,
									"title": "Mississippi",
									"question_id": 133097,
									"round_id": 21219,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342625,
									"title": "Ohio",
									"question_id": 133097,
									"round_id": 21219,
									"value": 1,
									"percents": 100
								}
							]
						}
					]
				},
				{
					"id": 21220,
					"position": 2,
					"sponsor": null,
					"status": "complete",
					"name": "omg",
					"category": "Fashion and Beauty",
					"tag_line": "Fashion, Beauty, and Other Unattainables",
					"type": "rapid_fire_2",
					"time_to_answer": 20,
					"start_date_time": "2021-05-24T08:25:48-04:00",
					"number_questions": 5,
					"points_per_question": 20,
					"time_until_next_round": 293,
					"bonus_points": 50,
					"questions": [
						{
							"id": 133098,
							"position": 1,
							"round_id": 21220,
							"status": "complete",
							"title": "Which of these does the Nike trademark called a \"swoosh\" most resemble?",
							"category": "Fashion and Beauty",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:25:48-04:00",
							"end_date_time": "2021-05-24T08:26:08-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342626,
									"title": "A Number Sign",
									"question_id": 133098,
									"round_id": 21220,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342627,
									"title": "A Check Mark",
									"question_id": 133098,
									"round_id": 21220,
									"value": 1,
									"percents": 100
								},
								{
									"id": 342628,
									"title": "A Peace Sign",
									"question_id": 133098,
									"round_id": 21220,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342629,
									"title": "A Star",
									"question_id": 133098,
									"round_id": 21220,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133099,
							"position": 2,
							"round_id": 21220,
							"status": "complete",
							"title": "According to a well-known movie starring Meryl Streep, the devil wears Prada.",
							"category": "Fashion and Beauty",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:26:25-04:00",
							"end_date_time": "2021-05-24T08:26:45-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342630,
									"title": "TRUE",
									"question_id": 133099,
									"round_id": 21220,
									"value": 1,
									"percents": 83.33
								},
								{
									"id": 342631,
									"title": "FALSE",
									"question_id": 133099,
									"round_id": 21220,
									"value": 0,
									"percents": 16.67
								}
							]
						},
						{
							"id": 133100,
							"position": 3,
							"round_id": 21220,
							"status": "complete",
							"title": "Which French monarch was known for his fancy taste, especially in velvets and laces?",
							"category": "Fashion and Beauty",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:27:02-04:00",
							"end_date_time": "2021-05-24T08:27:22-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342632,
									"title": "Napoleon",
									"question_id": 133100,
									"round_id": 21220,
									"value": 0,
									"percents": 20
								},
								{
									"id": 342633,
									"title": "King Louis XIV",
									"question_id": 133100,
									"round_id": 21220,
									"value": 1,
									"percents": 60
								},
								{
									"id": 342634,
									"title": "Ivan The Terrible",
									"question_id": 133100,
									"round_id": 21220,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342635,
									"title": "Charlemagne",
									"question_id": 133100,
									"round_id": 21220,
									"value": 0,
									"percents": 20
								}
							]
						},
						{
							"id": 133101,
							"position": 4,
							"round_id": 21220,
							"status": "complete",
							"title": "In 2019, Forbes categorized Kylie Jenner as a billionaire due to the success of her cosmetics company.",
							"category": "Fashion and Beauty",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:27:39-04:00",
							"end_date_time": "2021-05-24T08:27:59-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342636,
									"title": "TRUE",
									"question_id": 133101,
									"round_id": 21220,
									"value": 1,
									"percents": 66.67
								},
								{
									"id": 342637,
									"title": "FALSE",
									"question_id": 133101,
									"round_id": 21220,
									"value": 0,
									"percents": 33.33
								}
							]
						},
						{
							"id": 133102,
							"position": 5,
							"round_id": 21220,
							"status": "complete",
							"title": "By what name do we know the item Whitcomb Judson called a \"clasp locker\"?",
							"category": "Fashion and Beauty",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:28:16-04:00",
							"end_date_time": "2021-05-24T08:28:36-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342638,
									"title": "Velcro",
									"question_id": 133102,
									"round_id": 21220,
									"value": 0,
									"percents": 50
								},
								{
									"id": 342639,
									"title": "Snap",
									"question_id": 133102,
									"round_id": 21220,
									"value": 0,
									"percents": 37.5
								},
								{
									"id": 342640,
									"title": "Button Fly",
									"question_id": 133102,
									"round_id": 21220,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342641,
									"title": "Zipper",
									"question_id": 133102,
									"round_id": 21220,
									"value": 1,
									"percents": 12.5
								}
							]
						}
					]
				},
				{
					"id": 21222,
					"position": 3,
					"sponsor": null,
					"status": "scheduled",
					"name": "balls_and_bats",
					"category": "Sports",
					"tag_line": "Sports Trivia; Because we're a sports bar",
					"type": "rapid_fire_2",
					"time_to_answer": 20,
					"start_date_time": "2021-05-24T08:33:36-04:00",
					"number_questions": 5,
					"points_per_question": 20,
					"time_until_next_round": 285,
					"bonus_points": 50,
					"questions": [
						{
							"id": 133103,
							"position": 1,
							"round_id": 21222,
							"status": "complete",
							"title": "Stephen Curry scored 62 points in January 2021 against which team?",
							"category": "Sports",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:33:36-04:00",
							"end_date_time": "2021-05-24T08:33:56-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342642,
									"title": "Lakers",
									"question_id": 133103,
									"round_id": 21222,
									"value": 0,
									"percents": 14.29
								},
								{
									"id": 342643,
									"title": "Magic",
									"question_id": 133103,
									"round_id": 21222,
									"value": 0,
									"percents": 14.29
								},
								{
									"id": 342644,
									"title": "Trail Blazers",
									"question_id": 133103,
									"round_id": 21222,
									"value": 1,
									"percents": 71.43
								},
								{
									"id": 342645,
									"title": "Bulls",
									"question_id": 133103,
									"round_id": 21222,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133104,
							"position": 2,
							"round_id": 21222,
							"status": "complete",
							"title": "Chicago Loyola was the first 16 seed to ever defeat a #1 seed in the NCAA men's basketball tournament.",
							"category": "Sports",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:34:13-04:00",
							"end_date_time": "2021-05-24T08:34:33-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342646,
									"title": "TRUE",
									"question_id": 133104,
									"round_id": 21222,
									"value": 0,
									"percents": 77.78
								},
								{
									"id": 342647,
									"title": "FALSE",
									"question_id": 133104,
									"round_id": 21222,
									"value": 1,
									"percents": 22.22
								}
							]
						},
						{
							"id": 133105,
							"position": 3,
							"round_id": 21222,
							"status": "complete",
							"title": "What did the Cavs get for the trade of Kevin Porter Jr. to the Rockets in 2021?",
							"category": "Sports",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:34:50-04:00",
							"end_date_time": "2021-05-24T08:35:10-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342648,
									"title": "Rodions Kurucs",
									"question_id": 133105,
									"round_id": 21222,
									"value": 0,
									"percents": 33.33
								},
								{
									"id": 342649,
									"title": "Future Second-Round Pick",
									"question_id": 133105,
									"round_id": 21222,
									"value": 1,
									"percents": 33.33
								},
								{
									"id": 342650,
									"title": "Cash",
									"question_id": 133105,
									"round_id": 21222,
									"value": 0,
									"percents": 11.11
								},
								{
									"id": 342651,
									"title": "Future First-Round Pick",
									"question_id": 133105,
									"round_id": 21222,
									"value": 0,
									"percents": 22.22
								}
							]
						},
						{
							"id": 133106,
							"position": 4,
							"round_id": 21222,
							"status": "complete",
							"title": "In 2020, the Buffalo Bills won the AFC East for the first time since 1993.",
							"category": "Sports",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:35:27-04:00",
							"end_date_time": "2021-05-24T08:35:47-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342652,
									"title": "TRUE",
									"question_id": 133106,
									"round_id": 21222,
									"value": 1,
									"percents": 87.5
								},
								{
									"id": 342653,
									"title": "FALSE",
									"question_id": 133106,
									"round_id": 21222,
									"value": 0,
									"percents": 12.5
								}
							]
						},
						{
							"id": 133107,
							"position": 5,
							"round_id": 21222,
							"status": "complete",
							"title": "Who won the NHL's Norris Trophy every year from 1968 to 1975?",
							"category": "Sports",
							"answer_type": "multiple_choice",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:36:04-04:00",
							"end_date_time": "2021-05-24T08:36:24-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342654,
									"title": "Bobby Orr",
									"question_id": 133107,
									"round_id": 21222,
									"value": 1,
									"percents": 75
								},
								{
									"id": 342655,
									"title": "Bobby Hull",
									"question_id": 133107,
									"round_id": 21222,
									"value": 0,
									"percents": 12.5
								},
								{
									"id": 342656,
									"title": "Larry Robinson",
									"question_id": 133107,
									"round_id": 21222,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342657,
									"title": "Wayne Gretzky",
									"question_id": 133107,
									"round_id": 21222,
									"value": 0,
									"percents": 12.5
								}
							]
						}
					]
				},
				{
					"id": 21226,
					"position": 4,
					"sponsor": "michelob_ultra_dulce_vida",
					"status": "scheduled",
					"name": "michelob_ultra_dulce_vida",
					"category": "Two Rights and a Wrong",
					"tag_line": "",
					"type": "right_right_wrong",
					"time_to_answer": 20,
					"start_date_time": "2021-05-24T08:41:16-04:00",
					"number_questions": 5,
					"points_per_question": 20,
					"time_until_next_round": 362,
					"bonus_points": 50,
					"questions": [
						{
							"id": 133114,
							"position": 1,
							"round_id": 21226,
							"status": "complete",
							"title": "Stephen \"Steph\" Curry",
							"category": "Two Rights and a Wrong",
							"answer_type": "multi_select",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:41:16-04:00",
							"end_date_time": "2021-05-24T08:41:36-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342669,
									"title": "Duke University",
									"question_id": 133114,
									"round_id": 21226,
									"value": 0,
									"percents": 30.77
								},
								{
									"id": 342670,
									"title": "Ayesha Curry",
									"question_id": 133114,
									"round_id": 21226,
									"value": 1,
									"percents": 69.23
								}
							]
						},
						{
							"id": 133115,
							"position": 2,
							"round_id": 21226,
							"status": "complete",
							"title": "Major League Baseball Managers 2021",
							"category": "Two Rights and a Wrong",
							"answer_type": "multi_select",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:41:53-04:00",
							"end_date_time": "2021-05-24T08:42:13-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342671,
									"title": "Craig Counsell",
									"question_id": 133115,
									"round_id": 21226,
									"value": 1,
									"percents": 71.43
								},
								{
									"id": 342672,
									"title": "Al Avila",
									"question_id": 133115,
									"round_id": 21226,
									"value": 0,
									"percents": 28.57
								}
							]
						},
						{
							"id": 133116,
							"position": 3,
							"round_id": 21226,
							"status": "complete",
							"title": "Olympic Swimmers",
							"category": "Two Rights and a Wrong",
							"answer_type": "multi_select",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:42:30-04:00",
							"end_date_time": "2021-05-24T08:42:50-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342673,
									"title": "Matt Biondi",
									"question_id": 133116,
									"round_id": 21226,
									"value": 1,
									"percents": 23.08
								},
								{
									"id": 342674,
									"title": "Ryan Lochte",
									"question_id": 133116,
									"round_id": 21226,
									"value": 1,
									"percents": 76.92
								}
							]
						},
						{
							"id": 133117,
							"position": 4,
							"round_id": 21226,
							"status": "complete",
							"title": "NBA Head Coaches 2021",
							"category": "Two Rights and a Wrong",
							"answer_type": "multi_select",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:43:07-04:00",
							"end_date_time": "2021-05-24T08:43:27-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342675,
									"title": "Chris Lynn",
									"question_id": 133117,
									"round_id": 21226,
									"value": 0,
									"percents": 69.23
								},
								{
									"id": 342676,
									"title": "Michael Malone",
									"question_id": 133117,
									"round_id": 21226,
									"value": 1,
									"percents": 30.77
								}
							]
						},
						{
							"id": 133118,
							"position": 5,
							"round_id": 21226,
							"status": "complete",
							"title": "Archery Terms",
							"category": "Two Rights and a Wrong",
							"answer_type": "multi_select",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:43:44-04:00",
							"end_date_time": new Date(Date.now() + 20 * 1000),
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342677,
									"title": "Hug the Rail",
									"question_id": 133118,
									"round_id": 21226,
									"value": 0,
									"percents": 53.85
								},
								{
									"id": 342678,
									"title": "Bowyer",
									"question_id": 133118,
									"round_id": 21226,
									"value": 1,
									"percents": 46.15
								}
							]
						}
					]
				},
				{
					"id": 21223,
					"position": 5,
					"sponsor": null,
					"status": "scheduled",
					"name": "blazin_round",
					"category": "Swipe It",
					"tag_line": "To know us is to love us",
					"type": "this_or_that",
					"time_to_answer": 12,
					"start_date_time": "2021-05-24T08:50:13-04:00",
					"number_questions": 5,
					"points_per_question": 30,
					"time_until_next_round": 280,
					"bonus_points": 50,
					"questions": [
						{
							"id": 133108,
							"position": 1,
							"round_id": 21223,
							"status": "complete",
							"title": "Michigan",
							"category": "Swipe It",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:50:13-04:00",
							"end_date_time": "2021-05-24T08:50:25-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342658,
									"title": "States West of the Mississippi",
									"question_id": 133108,
									"round_id": 21223,
									"value": 0,
									"percents": 12.5
								},
								{
									"id": 342659,
									"title": "States East of the Mississippi",
									"question_id": 133108,
									"round_id": 21223,
									"value": 1,
									"percents": 87.5
								}
							]
						},
						{
							"id": 133109,
							"position": 2,
							"round_id": 21223,
							"status": "complete",
							"title": "Kansas Michigan Michigan Michigan Michigan Michigan Michigan Michigan Michigan Michigan Michigan Michigan Michigan  ",
							"category": "Swipe It",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:50:25-04:00",
							"end_date_time": "2021-05-24T08:50:37-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342660,
									"title": "States West of the Mississippi",
									"question_id": 133109,
									"round_id": 21223,
									"value": 1,
									"percents": 87.5
								},
								{
									"id": 342661,
									"title": "States East of the Mississippi",
									"question_id": 133109,
									"round_id": 21223,
									"value": 0,
									"percents": 12.5
								}
							]
						},
						{
							"id": 133110,
							"position": 3,
							"round_id": 21223,
							"status": "complete",
							"title": "Idaho",
							"category": "Swipe It",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:50:37-04:00",
							"end_date_time": "2021-05-24T08:50:49-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342662,
									"title": "States West of the Mississippi",
									"question_id": 133110,
									"round_id": 21223,
									"value": 1,
									"percents": 100
								},
								{
									"id": 342663,
									"title": "States East of the Mississippi",
									"question_id": 133110,
									"round_id": 21223,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133111,
							"position": 4,
							"round_id": 21223,
							"status": "complete",
							"title": "Louisiana",
							"category": "Swipe It",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:50:49-04:00",
							"end_date_time": "2021-05-24T08:51:01-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342664,
									"title": "States West of the Mississippi",
									"question_id": 133111,
									"round_id": 21223,
									"value": 1,
									"percents": 37.5
								},
								{
									"id": 342665,
									"title": "States East of the Mississippi",
									"question_id": 133111,
									"round_id": 21223,
									"value": 0,
									"percents": 62.5
								}
							]
						},
						{
							"id": 133112,
							"position": 5,
							"round_id": 21223,
							"status": "complete",
							"title": "Mississippi",
							"category": "Swipe It",
							"answer_type": "binary",
							"fun_fact": null,
							"start_date_time": "2021-05-24T08:51:01-04:00",
							"end_date_time": "2021-05-24T08:51:13-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342666,
									"title": "States West of the Mississippi",
									"question_id": 133112,
									"round_id": 21223,
									"value": 0,
									"percents": 25
								},
								{
									"id": 342667,
									"title": "States East of the Mississippi",
									"question_id": 133112,
									"round_id": 21223,
									"value": 1,
									"percents": 75
								}
							]
						}
					]
				},
				{
					"id": 21224,
					"position": 6,
					"sponsor": null,
					"status": "scheduled",
					"name": "goat",
					"category": "All",
					"tag_line": "In Case You Missed It",
					"type": "normal",
					"time_to_answer": 20,
					"start_date_time": "2021-05-24T08:56:03-04:00",
					"number_questions": 2,
					"points_per_question": 20,
					"time_until_next_round": 325,
					"bonus_points": 50,
					"questions": [
						{
							"id": 133119,
							"position": 1,
							"round_id": 21224,
							"status": "complete",
							"title": "The movie “Shrek” was released 20 years ago. Who was originally cast to play the titular ogre?",
							"category": "All",
							"answer_type": "multiple_choice",
							"fun_fact": "The former “Saturday Night Live” star Chris Farley was originally cast and had recorded many of his lines before his death in 1997.",
							"start_date_time": "2021-05-24T08:56:03-04:00",
							"end_date_time": "2021-05-24T08:56:23-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 10,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": false,
							"answer_choices": [
								{
									"id": 342679,
									"title": "Eddie Murphy",
									"question_id": 133119,
									"round_id": 21224,
									"value": 0,
									"percents": 20
								},
								{
									"id": 342680,
									"title": "Jack Black",
									"question_id": 133119,
									"round_id": 21224,
									"value": 0,
									"percents": 20
								},
								{
									"id": 342681,
									"title": "Chris Farley",
									"question_id": 133119,
									"round_id": 21224,
									"value": 1,
									"percents": 60
								},
								{
									"id": 342682,
									"title": "Mike Myers",
									"question_id": 133119,
									"round_id": 21224,
									"value": 0,
									"percents": 0
								}
							]
						},
						{
							"id": 133120,
							"position": 2,
							"round_id": 21224,
							"status": "complete",
							"title": "Phil Mickelson won the PGA championship over the weekend. How many major championships has he won?",
							"category": "All",
							"answer_type": "multiple_choice",
							"fun_fact": "",
							"start_date_time": "2021-05-24T08:56:50-04:00",
							"end_date_time": "2021-05-24T08:57:10-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342683,
									"title": "Five",
									"question_id": 133120,
									"round_id": 21224,
									"value": 0,
									"percents": 16.67
								},
								{
									"id": 342684,
									"title": "Ten",
									"question_id": 133120,
									"round_id": 21224,
									"value": 0,
									"percents": 0
								},
								{
									"id": 342685,
									"title": "Four",
									"question_id": 133120,
									"round_id": 21224,
									"value": 0,
									"percents": 5.56
								},
								{
									"id": 342686,
									"title": "Six",
									"question_id": 133120,
									"round_id": 21224,
									"value": 1,
									"percents": 77.78
								}
							]
						}
					]
				},
				{
					"id": 21225,
					"position": 7,
					"sponsor": null,
					"status": "scheduled",
					"name": "finals",
					"category": "Literature",
					"tag_line": "GOATs only.",
					"type": "wager",
					"time_to_answer": 20,
					"start_date_time": "2021-05-24T09:02:42-04:00",
					"number_questions": 1,
					"points_per_question": 50,
					"time_until_next_round": 60,
					"bonus_points": 0,
					"questions": [
						{
							"id": 133113,
							"position": 1,
							"round_id": 21225,
							"status": "complete",
							"title": "Who wrote the book \"The Count of Monte Cristo\"?",
							"category": "Finals",
							"answer_type": "free_response",
							"fun_fact": null,
							"start_date_time": "2021-05-24T09:02:42-04:00",
							"end_date_time": "2021-05-24T09:03:02-04:00",
							"time_to_results": 2,
							"time_to_fan_fact": 0,
							"time_to_bubbles_message": 5,
							"levenshtein_percents": 70,
							"is_last": true,
							"answer_choices": [
								{
									"id": 342668,
									"title": "",
									"question_id": 133113,
									"round_id": 21225,
									"value": "Alexandre Dumas",
									"variants": [
										"Alexandre Dumas"
									],
									"percents": 16.67
								}
							]
						}
					]
				}
			]
		},
	]
;

// tslint:disable-next-line:fractal-control-default-export
export default data;
